var Typeahead, ax, base, base1, getAutocompleteList, getRecentSearches, moveAutocomplete, ref, removeRecentSearch, removeRecentSearches, setRecentSearches,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ref = require('../helper/m_typeahead_helper'), getAutocompleteList = ref.getAutocompleteList, getRecentSearches = ref.getRecentSearches, moveAutocomplete = ref.moveAutocomplete, removeRecentSearch = ref.removeRecentSearch, removeRecentSearches = ref.removeRecentSearches, setRecentSearches = ref.setRecentSearches;

ax = require('../helper/m_common').ax;

module.exports = Typeahead = (function() {
  function Typeahead(opts) {
    this.buildAutocompleteList = bind(this.buildAutocompleteList, this);
    this.removeTabIndex = bind(this.removeTabIndex, this);
    this.rerender = bind(this.rerender, this);
    this.success = bind(this.success, this);
    var ref1, ref2, ref3;
    this.env = opts.env, this.hasBetterUx = opts.enableBetterUx, this.hasGeolocation = opts.enableGeolocation, this.hasSearchCategories = opts.enableSearchCategories, this.endpoints = opts.endpoints, this.experiments = opts.experiments, this.$container = opts.resultList;
    this.query = '';
    this.ctx = 'search';
    this.$form = $('#search-bar, #ls-search-form');
    this.$inputs = this.$form.find('input');
    this.$search = this.$form.find('#search, #ls-search');
    this.$location = this.$form.find('#location, #ls-location');
    this.lat = typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.division) != null ? ref1.lat : void 0 : void 0;
    this.lng = typeof Groupon !== "undefined" && Groupon !== null ? (ref2 = Groupon.division) != null ? ref2.lng : void 0 : void 0;
    this.locale = document.head.getAttribute('data-locale');
    this.consumer_id = Cookie.get('snickerdoodle');
    this.result = [];
    this.hasRecentSearches = false;
    this.hasRecentLocations = false;
    if (opts.enableRecentSearches) {
      this.getRecentSearches();
    }
    if (opts.enableRecentLocations) {
      this.getRecentLocations();
    }
    if ((ref3 = Groupon.LS) != null ? ref3.hasTouch : void 0) {
      this.setBHViewport();
    }
    this.bind();
  }

  Typeahead.prototype.bind = function() {
    this.$container.on('click', '.tw-item .tw-clear', (function(_this) {
      return function(e) {
        var $item, ctx, value;
        e.preventDefault();
        e.stopImmediatePropagation();
        $item = $(e.currentTarget).siblings('.tw-link');
        if (!(value = $item.attr('data-value'))) {
          return;
        }
        ctx = _this.ctx;
        removeRecentSearch(value, ctx);
        _this.rerender(e, ctx);
      };
    })(this));
    this.$container.on('click', '.tw-heading .tw-clear', (function(_this) {
      return function(e) {
        var ctx;
        ctx = _this.ctx;
        removeRecentSearches(ctx);
        _this.rerender(e, ctx);
      };
    })(this));
  };


  /*
   * Fetch relevance API (deal / location)
   *
   * @param {String} query - Term to search
   */

  Typeahead.prototype.fetch = function(query) {
    var ell, lat, lng, ref1;
    if ($('.ls-error-dialog').length) {
      return;
    }
    if (this.env === 'desktop') {
      if (Groupon.LS.experiments['LS-2426-use-ell-for-relevance'] && ((ell = Cookie.get('ell')) != null)) {
        ref1 = ell.split(','), lat = ref1[0], lng = ref1[1];
      } else {
        lat = this.lat;
        lng = this.lng;
      }
    }
    this.query = query;
    return $.ajax({
      url: this.endpoints[this.ctx],
      contentType: "application/json; charset=utf-8",
      dataType: "jsonp",
      type: 'get',
      data: {
        query: this.query,
        limit: 10,
        lat: this.lat,
        lng: this.lng,
        locale: this.locale,
        consumer_id: this.consumer_id
      },
      cache: false,
      success: this.success,
      error: (function(_this) {
        return function() {
          return _this.reset();
        };
      })(this)
    });
  };


  /*
   * Success handler for relevance API call.
   * Selects and updates response.
   *
   * @param {Object} res - Object containing API response for either deal or location
   */

  Typeahead.prototype.success = function(res) {
    var deals, locations, result;
    if ($('.ls-error-dialog').length) {
      return;
    }
    locations = res.locationsAutocompleteResults, deals = res.dealsAutocompleteResults;
    result = [];
    if (deals != null ? deals.length : void 0) {
      result = [
        {
          collection: deals,
          widget: 'autocomplete'
        }
      ];
    } else if (locations != null ? locations.length : void 0) {
      result = [
        {
          collection: locations,
          widget: 'autocomplete'
        }
      ];
    }
    if (this.hasGeolocation && locations) {
      result.unshift({
        collection: [],
        widget: 'geolocation'
      });
    }
    if (result.length) {
      this.result = _.deepClone(result);
    }
    this.buildView(this.result, this.query);
  };


  /*
   * Generate typeahead html and append to typeahead container
   *
   * @param {Array}  collections - Updated
   * @param {String} query
   */

  Typeahead.prototype.buildView = function(collections, query) {
    var $container, bh, bhw, index, list, prefix, ref1;
    this.reset();
    if (!collections.length) {
      return;
    }
    $container = this.$container;
    ref1 = getAutocompleteList(collections, query, {
      experiments: this.experiments
    }), list = ref1.list, index = ref1.index, bh = ref1.bh, prefix = ref1.prefix;
    if (list != null ? list.length : void 0) {
      list.unshift("<ul role='list' data-" + bh.type + "='" + bh.val + "'>");
      list.push('</ul>');
      switch (this.ctx) {
        case 'search':
          bhw = 'DealSearchBarAutoComplete';
          if (prefix) {
            this.$search.attr('aria-activedescendant', prefix + '0');
          }
          break;
        case 'location':
          bhw = 'LocationSearchBarAutoComplete';
          if (prefix) {
            this.$location.attr('aria-activedescendant', prefix + '0');
          }
      }
      $container.removeClass('typeahead-search typeahead-location').addClass('typeahead-' + this.ctx).html(list.join('')).attr('data-bhw', bhw).show();
      ax.show($container, this.removeTabIndex);
      if (this.env === 'desktop' && index > -1) {
        this.highlightMatch($container);
      }
    } else {
      ax.hide($container);
      $container.hide();
    }
  };

  Typeahead.prototype.rerender = function(e, ctx) {
    switch (ctx) {
      case 'search':
        this.getRecentSearches();
        break;
      case 'location':
        this.getRecentLocations();
    }
    if (e != null) {
      e.currentTarget.id = ctx;
    }
    this.buildAutocompleteList(e, ctx);
  };

  Typeahead.prototype.removeTabIndex = function() {
    return this.$container.removeAttr('tabindex');
  };


  /*
   * Clear typeahead list
   */

  Typeahead.prototype.reset = function() {
    this.$container.find('ul').empty();
    ax.hide(this.containers);
    this.$inputs.removeAttr('aria-activedescendant');
  };

  Typeahead.prototype.hide = function() {
    this.reset();
    return this.$container.hide().attr('aria-hidden', 'true').empty();
  };


  /*
   * Method triggered by deal / location input events to decide
   * the type of typeahead and emit relevance ajax request
   *
   * @param {Object} e   - jQuery event
   * @param {String} ctx - Context: 'search' or 'location' input
   */

  Typeahead.prototype.buildAutocompleteList = function(e, ctx) {
    var id, query, ref1;
    if (e != null) {
      e.preventDefault();
    }
    this.ctx = ctx;
    ref1 = e.currentTarget, id = ref1.id, query = ref1.value;
    moveAutocomplete(this.$container, ctx, this.env);
    if (e.type === 'focusin' && id === 'ls-location') {
      query = '';
    } else {
      query = (query != null ? query.trim() : void 0) || '';
    }
    if (!query) {
      this.reset();
      switch (id) {
        case 'search':
        case 'ls-search':
          this.showDealWidget();
          break;
        case 'location':
        case 'ls-location':
          this.showLocationWidget();
      }
    } else {
      switch (e.type) {
        case 'input':
          if (query !== this.query) {
            this.fetch(query);
          }
          break;
        default:
          this.fetch(query);
      }
    }
  };

  Typeahead.prototype.getRecentSearches = function() {
    var ref1;
    this.recentKeywords = getRecentSearches('deal');
    return this.hasRecentSearches = ((ref1 = this.recentKeywords) != null ? ref1.length : void 0) > 0;
  };

  Typeahead.prototype.getRecentLocations = function() {
    var locations, ref1;
    locations = getRecentSearches('location');
    this.recentLocations = locations.filter(function(e) {
      return e.hasOwnProperty('division');
    });
    if (((ref1 = this.recentLocations) != null ? ref1.length : void 0) > 0) {
      if (this.recentLocations.length !== locations.length) {
        setRecentSearches(this.recentLocations, 'location');
      }
      if (typeof this.recentLocations[0] === 'object') {
        return this.hasRecentLocations = true;
      } else {
        return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.removeItem('LS_recentLocations') : void 0;
      }
    }
  };

  Typeahead.prototype.highlightMatch = function($list) {
    var $matchedItem;
    $matchedItem = $list.find('.typeahead-match');
    return $list.on({
      mouseenter: function() {
        document.activeElement.blur();
        return $matchedItem.removeClass('typeahead-match-highlight');
      },
      mouseleave: function() {
        return $matchedItem.addClass('typeahead-match-highlight');
      }
    });
  };


  /*
   * Build configurable collections for deal typeahead when input is empty
   */

  Typeahead.prototype.showDealWidget = function() {
    var collections, hasRecentSearches, hasSearchCategories, keywords, ref1, ref2, ref3;
    hasRecentSearches = this.hasRecentSearches;
    hasSearchCategories = this.hasSearchCategories;
    if (!this.searchCategories) {
      this.searchCategories = ((ref1 = Groupon.LS.data) != null ? ref1.searchCategories : void 0) || [];
      this.hasSearchCategories = hasSearchCategories = ((ref2 = this.searchCategories) != null ? ref2.length : void 0) > 0;
    }
    if (hasRecentSearches || hasSearchCategories) {
      collections = [];
      if (hasRecentSearches) {
        keywords = (ref3 = this.recentKeywords) != null ? ref3.slice(0) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentSearches'
          }
        ]);
      }
      if (hasSearchCategories) {
        collections.push.apply(collections, [
          {
            collection: this.searchCategories.slice(0),
            widget: 'searchCategories'
          }
        ]);
      }
      if (collections != null ? collections.length : void 0) {
        this.buildView(collections);
      }
    }
  };


  /*
   * Build configurable collections for location typeahead when input is empty
   */

  Typeahead.prototype.showLocationWidget = function() {
    var collections, hasBetterUx, hasGeolocation, hasRecentLocations, keywords, ref1;
    hasGeolocation = this.hasGeolocation;
    hasRecentLocations = this.hasRecentLocations;
    hasBetterUx = this.hasBetterUx;
    if (hasGeolocation || hasRecentLocations || hasBetterUx) {
      collections = [];
      if (hasGeolocation) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'geolocation'
          }
        ]);
      }
      if (hasBetterUx) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'helperMessage'
          }
        ]);
      }
      if (hasRecentLocations) {
        keywords = (ref1 = this.recentLocations) != null ? ref1.slice(0, 5) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentLocations'
          }
        ]);
      }
      if (collections != null ? collections.length : void 0) {
        this.buildView(collections);
      }
    }
  };


  /*
   * Prevent bloodhound impression tracking on typeahead due to performance reasons
   */

  Typeahead.prototype.setBHViewport = function(state) {
    if (state == null) {
      state = 'ignore';
    }
    this.$container.attr('data-bh-viewport', state);
  };

  return Typeahead;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

if ((base1 = window.Groupon.Modules.SearchBar).View == null) {
  base1.View = {};
}

_.extend(window.Groupon.Modules.SearchBar.View, {
  Typeahead: Typeahead
});

//# sourceMappingURL=data:application/json;base64,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
